var Typeahead, ax, base, base1, getAutocompleteList, getRecentSearches, moveAutocomplete, ref, removeRecentSearch, removeRecentSearches, setRecentSearches,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ref = require('../helper/m_typeahead_helper'), getAutocompleteList = ref.getAutocompleteList, getRecentSearches = ref.getRecentSearches, moveAutocomplete = ref.moveAutocomplete, removeRecentSearch = ref.removeRecentSearch, removeRecentSearches = ref.removeRecentSearches, setRecentSearches = ref.setRecentSearches;

ax = require('../helper/m_common').ax;

module.exports = Typeahead = (function() {
  function Typeahead(opts) {
    this.buildAutocompleteList = bind(this.buildAutocompleteList, this);
    this.removeTabIndex = bind(this.removeTabIndex, this);
    this.rerender = bind(this.rerender, this);
    this.success = bind(this.success, this);
    var ref1, ref2, ref3;
    this.env = opts.env, this.hasBetterUx = opts.enableBetterUx, this.hasGeolocation = opts.enableGeolocation, this.hasSearchCategories = opts.enableSearchCategories, this.endpoints = opts.endpoints, this.experiments = opts.experiments, this.$container = opts.resultList;
    this.query = '';
    this.ctx = 'search';
    this.$form = $('#search-bar, #ls-search-form');
    this.$inputs = this.$form.find('input');
    this.$search = this.$form.find('#search, #ls-search');
    this.$location = this.$form.find('#location, #ls-location');
    this.lat = typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.division) != null ? ref1.lat : void 0 : void 0;
    this.lng = typeof Groupon !== "undefined" && Groupon !== null ? (ref2 = Groupon.division) != null ? ref2.lng : void 0 : void 0;
    this.locale = document.head.getAttribute('data-locale');
    this.consumer_id = Cookie.get('snickerdoodle');
    this.result = [];
    this.hasRecentSearches = false;
    this.hasRecentLocations = false;
    if (opts.enableRecentSearches) {
      this.getRecentSearches();
    }
    if (opts.enableRecentLocations) {
      this.getRecentLocations();
    }
    if ((ref3 = Groupon.LS) != null ? ref3.hasTouch : void 0) {
      this.setBHViewport();
    }
    this.bind();
  }

  Typeahead.prototype.bind = function() {
    this.$container.on('click', '.tw-item .tw-clear', (function(_this) {
      return function(e) {
        var $item, ctx, value;
        e.preventDefault();
        e.stopImmediatePropagation();
        $item = $(e.currentTarget).siblings('.tw-link');
        if (!(value = $item.attr('data-value'))) {
          return;
        }
        ctx = _this.ctx;
        removeRecentSearch(value, ctx);
        _this.rerender(e, ctx);
      };
    })(this));
    this.$container.on('click', '.tw-heading .tw-clear', (function(_this) {
      return function(e) {
        var ctx;
        ctx = _this.ctx;
        removeRecentSearches(ctx);
        _this.rerender(e, ctx);
      };
    })(this));
  };


  /*
   * Fetch relevance API (deal / location)
   *
   * @param {String} query - Term to search
   */

  Typeahead.prototype.fetch = function(query) {
    var ell, lat, lng, ref1;
    if ($('.ls-error-dialog').length) {
      return;
    }
    if (this.env === 'desktop') {
      if (Groupon.LS.experiments['LS-2426-use-ell-for-relevance'] && ((ell = Cookie.get('ell')) != null)) {
        ref1 = ell.split(','), lat = ref1[0], lng = ref1[1];
      } else {
        lat = this.lat;
        lng = this.lng;
      }
    }
    this.query = query;
    return $.ajax({
      url: this.endpoints[this.ctx],
      contentType: "application/json; charset=utf-8",
      dataType: "jsonp",
      type: 'get',
      data: {
        query: this.query,
        limit: 10,
        lat: this.lat,
        lng: this.lng,
        locale: this.locale,
        consumer_id: this.consumer_id
      },
      cache: false,
      success: this.success,
      error: (function(_this) {
        return function() {
          return _this.reset();
        };
      })(this)
    });
  };


  /*
   * Success handler for relevance API call.
   * Selects and updates response.
   *
   * @param {Object} res - Object containing API response for either deal or location
   */

  Typeahead.prototype.success = function(res) {
    var deals, locations, result;
    if ($('.ls-error-dialog').length) {
      return;
    }
    locations = res.locationsAutocompleteResults, deals = res.dealsAutocompleteResults;
    result = [];
    if (deals != null ? deals.length : void 0) {
      result = [
        {
          collection: deals,
          widget: 'autocomplete'
        }
      ];
    } else if (locations != null ? locations.length : void 0) {
      result = [
        {
          collection: locations,
          widget: 'autocomplete'
        }
      ];
    }
    if (this.hasGeolocation && locations) {
      result.unshift({
        collection: [],
        widget: 'geolocation'
      });
    }
    if (result.length) {
      this.result = _.deepClone(result);
    }
    this.buildView(this.result, this.query);
  };


  /*
   * Generate typeahead html and append to typeahead container
   *
   * @param {Array}  collections - Updated
   * @param {String} query
   */

  Typeahead.prototype.buildView = function(collections, query) {
    var $container, bh, bhw, index, list, prefix, ref1;
    this.reset();
    if (!collections.length) {
      return;
    }
    $container = this.$container;
    ref1 = getAutocompleteList(collections, query, {
      experiments: this.experiments
    }), list = ref1.list, index = ref1.index, bh = ref1.bh, prefix = ref1.prefix;
    if (list != null ? list.length : void 0) {
      list.unshift("<ul role='list' data-" + bh.type + "='" + bh.val + "'>");
      list.push('</ul>');
      switch (this.ctx) {
        case 'search':
          bhw = 'DealSearchBarAutoComplete';
          if (prefix) {
            this.$search.attr('aria-activedescendant', prefix + '0');
          }
          break;
        case 'location':
          bhw = 'LocationSearchBarAutoComplete';
          if (prefix) {
            this.$location.attr('aria-activedescendant', prefix + '0');
          }
      }
      $container.removeClass('typeahead-search typeahead-location').addClass('typeahead-' + this.ctx).html(list.join('')).attr('data-bhw', bhw).show();
      ax.show($container, this.removeTabIndex);
      if (this.env === 'desktop' && index > -1) {
        this.highlightMatch($container);
      }
    } else {
      ax.hide($container);
      $container.hide();
    }
  };

  Typeahead.prototype.rerender = function(e, ctx) {
    switch (ctx) {
      case 'search':
        this.getRecentSearches();
        break;
      case 'location':
        this.getRecentLocations();
    }
    if (e != null) {
      e.currentTarget.id = ctx;
    }
    this.buildAutocompleteList(e, ctx);
  };

  Typeahead.prototype.removeTabIndex = function() {
    return this.$container.removeAttr('tabindex');
  };


  /*
   * Clear typeahead list
   */

  Typeahead.prototype.reset = function() {
    this.$container.find('ul').empty();
    ax.hide(this.containers);
    this.$inputs.removeAttr('aria-activedescendant');
  };

  Typeahead.prototype.hide = function() {
    this.reset();
    return this.$container.hide().attr('aria-hidden', 'true').empty();
  };


  /*
   * Method triggered by deal / location input events to decide
   * the type of typeahead and emit relevance ajax request
   *
   * @param {Object} e   - jQuery event
   * @param {String} ctx - Context: 'search' or 'location' input
   */

  Typeahead.prototype.buildAutocompleteList = function(e, ctx) {
    var id, query, ref1;
    if (e != null) {
      e.preventDefault();
    }
    this.ctx = ctx;
    ref1 = e.currentTarget, id = ref1.id, query = ref1.value;
    moveAutocomplete(this.$container, ctx, this.env);
    if (e.type === 'focusin' && id === 'ls-location') {
      query = '';
    } else {
      query = (query != null ? query.trim() : void 0) || '';
    }
    if (!query) {
      this.reset();
      switch (id) {
        case 'search':
        case 'ls-search':
          this.showDealWidget();
          break;
        case 'location':
        case 'ls-location':
          this.showLocationWidget();
      }
    } else {
      switch (e.type) {
        case 'input':
          if (query !== this.query) {
            this.fetch(query);
          }
          break;
        default:
          this.fetch(query);
      }
    }
  };

  Typeahead.prototype.getRecentSearches = function() {
    var ref1;
    this.recentKeywords = getRecentSearches('deal');
    return this.hasRecentSearches = ((ref1 = this.recentKeywords) != null ? ref1.length : void 0) > 0;
  };

  Typeahead.prototype.getRecentLocations = function() {
    var locations, ref1;
    locations = getRecentSearches('location');
    this.recentLocations = locations.filter(function(e) {
      return e.hasOwnProperty('division');
    });
    if (((ref1 = this.recentLocations) != null ? ref1.length : void 0) > 0) {
      if (this.recentLocations.length !== locations.length) {
        setRecentSearches(this.recentLocations, 'location');
      }
      if (typeof this.recentLocations[0] === 'object') {
        return this.hasRecentLocations = true;
      } else {
        return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.removeItem('LS_recentLocations') : void 0;
      }
    }
  };

  Typeahead.prototype.highlightMatch = function($list) {
    var $matchedItem;
    $matchedItem = $list.find('.typeahead-match');
    return $list.on({
      mouseenter: function() {
        document.activeElement.blur();
        return $matchedItem.removeClass('typeahead-match-highlight');
      },
      mouseleave: function() {
        return $matchedItem.addClass('typeahead-match-highlight');
      }
    });
  };


  /*
   * Build configurable collections for deal typeahead when input is empty
   */

  Typeahead.prototype.showDealWidget = function() {
    var collections, hasRecentSearches, hasSearchCategories, keywords, ref1, ref2, ref3;
    hasRecentSearches = this.hasRecentSearches;
    hasSearchCategories = this.hasSearchCategories;
    if (!this.searchCategories) {
      this.searchCategories = ((ref1 = Groupon.LS.data) != null ? ref1.searchCategories : void 0) || [];
      this.hasSearchCategories = hasSearchCategories = ((ref2 = this.searchCategories) != null ? ref2.length : void 0) > 0;
    }
    if (hasRecentSearches || hasSearchCategories) {
      collections = [];
      if (hasRecentSearches) {
        keywords = (ref3 = this.recentKeywords) != null ? ref3.slice(0) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentSearches'
          }
        ]);
      }
      if (hasSearchCategories) {
        collections.push.apply(collections, [
          {
            collection: this.searchCategories.slice(0),
            widget: 'searchCategories'
          }
        ]);
      }
      if (collections != null ? collections.length : void 0) {
        this.buildView(collections);
      }
    }
  };


  /*
   * Build configurable collections for location typeahead when input is empty
   */

  Typeahead.prototype.showLocationWidget = function() {
    var collections, hasBetterUx, hasGeolocation, hasRecentLocations, keywords, ref1;
    hasGeolocation = this.hasGeolocation;
    hasRecentLocations = this.hasRecentLocations;
    hasBetterUx = this.hasBetterUx;
    if (hasGeolocation || hasRecentLocations || hasBetterUx) {
      collections = [];
      if (hasGeolocation) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'geolocation'
          }
        ]);
      }
      if (hasBetterUx) {
        collections.push.apply(collections, [
          {
            collection: [],
            widget: 'helperMessage'
          }
        ]);
      }
      if (hasRecentLocations) {
        keywords = (ref1 = this.recentLocations) != null ? ref1.slice(0, 5) : void 0;
        collections.push.apply(collections, [
          {
            collection: keywords,
            widget: 'recentLocations'
          }
        ]);
      }
      if (collections != null ? collections.length : void 0) {
        this.buildView(collections);
      }
    }
  };


  /*
   * Prevent bloodhound impression tracking on typeahead due to performance reasons
   */

  Typeahead.prototype.setBHViewport = function(state) {
    if (state == null) {
      state = 'ignore';
    }
    this.$container.attr('data-bh-viewport', state);
  };

  return Typeahead;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

if ((base1 = window.Groupon.Modules.SearchBar).View == null) {
  base1.View = {};
}

_.extend(window.Groupon.Modules.SearchBar.View, {
  Typeahead: Typeahead
});

//# sourceMappingURL=data:application/json;base64,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
